// Copyright 2025, compose-coui-ui contributors
// SPDX-License-Identifier: Apache-2.0

package io.github.suqi8.coui.kmp.icon.extended

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathNode
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.unit.dp
import io.github.suqi8.coui.kmp.icon.COUIIcons

val COUIIcons.VerticalSplit: ImageVector
    get() = COUIIcons.Regular.VerticalSplit

val COUIIcons.Light.VerticalSplit: ImageVector
    get() {
        if (_verticalsplitLight != null) return _verticalsplitLight!!
        _verticalsplitLight = ImageVector.Builder(
            name = "VerticalSplit.Light",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1132.8f,
            viewportHeight = 1132.8f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1132.8f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(920.9f, 177.8f),
                        PathNode.QuadTo(968.3f, 202.4f, 990.1f, 246.9f),
                        PathNode.QuadTo(1003.4f, 272.5f, 1006.6f, 309.6f),
                        PathNode.QuadTo(1009.9f, 346.8f, 1009.9f, 435.9f),
                        PathNode.VerticalTo(697.9f),
                        PathNode.QuadTo(1009.9f, 787.7f, 1006.6f, 824.5f),
                        PathNode.QuadTo(1003.4f, 861.3f, 990.1f, 886.8f),
                        PathNode.QuadTo(967.4f, 933.2f, 920.9f, 956.0f),
                        PathNode.QuadTo(895.4f, 969.2f, 858.6f, 972.5f),
                        PathNode.QuadTo(821.8f, 975.8f, 732.0f, 975.8f),
                        PathNode.HorizontalTo(399.8f),
                        PathNode.QuadTo(310.9f, 975.8f, 274.2f, 972.5f),
                        PathNode.QuadTo(237.4f, 969.2f, 210.9f, 956.0f),
                        PathNode.QuadTo(165.4f, 932.3f, 142.7f, 886.8f),
                        PathNode.QuadTo(129.4f, 861.3f, 126.2f, 824.5f),
                        PathNode.QuadTo(122.9f, 787.7f, 122.9f, 697.9f),
                        PathNode.VerticalTo(435.9f),
                        PathNode.QuadTo(122.9f, 346.8f, 126.2f, 309.6f),
                        PathNode.QuadTo(129.4f, 272.5f, 142.7f, 246.9f),
                        PathNode.QuadTo(164.5f, 203.3f, 210.9f, 177.8f),
                        PathNode.QuadTo(237.4f, 163.6f, 274.2f, 160.3f),
                        PathNode.QuadTo(310.9f, 157.0f, 399.8f, 157.0f),
                        PathNode.HorizontalTo(732.0f),
                        PathNode.QuadTo(821.8f, 157.0f, 858.6f, 160.3f),
                        PathNode.QuadTo(895.4f, 163.6f, 920.9f, 177.8f),
                        PathNode.Close,
                        PathNode.MoveTo(242.5f, 229.8f),
                        PathNode.QuadTo(211.3f, 246.4f, 193.8f, 276.7f),
                        PathNode.QuadTo(185.5f, 293.4f, 183.7f, 317.4f),
                        PathNode.QuadTo(181.8f, 341.5f, 181.8f, 392.8f),
                        PathNode.VerticalTo(702.6f),
                        PathNode.HorizontalTo(950.1f),
                        PathNode.VerticalTo(392.8f),
                        PathNode.QuadTo(950.1f, 341.5f, 948.2f, 317.8f),
                        PathNode.QuadTo(946.3f, 294.2f, 938.1f, 276.7f),
                        PathNode.QuadTo(924.2f, 249.2f, 890.2f, 229.8f),
                        PathNode.QuadTo(873.5f, 221.5f, 850.4f, 219.7f),
                        PathNode.QuadTo(827.3f, 217.8f, 774.1f, 217.8f),
                        PathNode.HorizontalTo(358.7f),
                        PathNode.QuadTo(305.5f, 217.8f, 282.3f, 219.7f),
                        PathNode.QuadTo(259.1f, 221.5f, 242.5f, 229.8f),
                        PathNode.Close,
                        PathNode.MoveTo(409.5f, 371.7f),
                        PathNode.VerticalTo(392.3f),
                        PathNode.QuadTo(409.5f, 403.7f, 404.6f, 409.2f),
                        PathNode.QuadTo(399.6f, 414.7f, 389.3f, 414.7f),
                        PathNode.HorizontalTo(309.3f),
                        PathNode.QuadTo(299.0f, 414.7f, 294.0f, 409.2f),
                        PathNode.QuadTo(289.1f, 403.7f, 289.1f, 392.3f),
                        PathNode.VerticalTo(371.7f),
                        PathNode.QuadTo(289.1f, 359.5f, 293.7f, 354.5f),
                        PathNode.QuadTo(298.2f, 349.4f, 309.3f, 349.4f),
                        PathNode.HorizontalTo(389.3f),
                        PathNode.QuadTo(400.4f, 349.4f, 405.0f, 354.5f),
                        PathNode.QuadTo(409.5f, 359.5f, 409.5f, 371.7f),
                        PathNode.Close,
                        PathNode.MoveTo(409.5f, 547.6f),
                        PathNode.VerticalTo(568.2f),
                        PathNode.QuadTo(409.5f, 579.6f, 404.6f, 585.1f),
                        PathNode.QuadTo(399.6f, 590.6f, 389.3f, 590.6f),
                        PathNode.HorizontalTo(309.3f),
                        PathNode.QuadTo(299.0f, 590.6f, 294.0f, 585.1f),
                        PathNode.QuadTo(289.1f, 579.6f, 289.1f, 568.2f),
                        PathNode.VerticalTo(547.6f),
                        PathNode.QuadTo(289.1f, 535.4f, 293.7f, 530.4f),
                        PathNode.QuadTo(298.2f, 525.3f, 309.3f, 525.3f),
                        PathNode.HorizontalTo(389.3f),
                        PathNode.QuadTo(400.4f, 525.3f, 405.0f, 530.4f),
                        PathNode.QuadTo(409.5f, 535.4f, 409.5f, 547.6f),
                        PathNode.Close,
                        PathNode.MoveTo(626.6f, 371.7f),
                        PathNode.VerticalTo(392.3f),
                        PathNode.QuadTo(626.6f, 403.7f, 621.6f, 409.2f),
                        PathNode.QuadTo(616.7f, 414.7f, 606.4f, 414.7f),
                        PathNode.HorizontalTo(526.4f),
                        PathNode.QuadTo(516.1f, 414.7f, 511.1f, 409.2f),
                        PathNode.QuadTo(506.2f, 403.7f, 506.2f, 392.3f),
                        PathNode.VerticalTo(371.7f),
                        PathNode.QuadTo(506.2f, 359.5f, 510.7f, 354.5f),
                        PathNode.QuadTo(515.3f, 349.4f, 526.4f, 349.4f),
                        PathNode.HorizontalTo(606.4f),
                        PathNode.QuadTo(617.5f, 349.4f, 622.1f, 354.5f),
                        PathNode.QuadTo(626.6f, 359.5f, 626.6f, 371.7f),
                        PathNode.Close,
                        PathNode.MoveTo(626.6f, 547.6f),
                        PathNode.VerticalTo(568.2f),
                        PathNode.QuadTo(626.6f, 579.6f, 621.6f, 585.1f),
                        PathNode.QuadTo(616.7f, 590.6f, 606.4f, 590.6f),
                        PathNode.HorizontalTo(526.4f),
                        PathNode.QuadTo(516.1f, 590.6f, 511.1f, 585.1f),
                        PathNode.QuadTo(506.2f, 579.6f, 506.2f, 568.2f),
                        PathNode.VerticalTo(547.6f),
                        PathNode.QuadTo(506.2f, 535.4f, 510.7f, 530.4f),
                        PathNode.QuadTo(515.3f, 525.3f, 526.4f, 525.3f),
                        PathNode.HorizontalTo(606.4f),
                        PathNode.QuadTo(617.5f, 525.3f, 622.1f, 530.4f),
                        PathNode.QuadTo(626.6f, 535.4f, 626.6f, 547.6f),
                        PathNode.Close,
                        PathNode.MoveTo(843.7f, 547.6f),
                        PathNode.VerticalTo(568.2f),
                        PathNode.QuadTo(843.7f, 579.6f, 838.7f, 585.1f),
                        PathNode.QuadTo(833.8f, 590.6f, 823.5f, 590.6f),
                        PathNode.HorizontalTo(743.5f),
                        PathNode.QuadTo(733.2f, 590.6f, 728.2f, 585.1f),
                        PathNode.QuadTo(723.3f, 579.6f, 723.3f, 568.2f),
                        PathNode.VerticalTo(547.6f),
                        PathNode.QuadTo(723.3f, 535.4f, 727.8f, 530.4f),
                        PathNode.QuadTo(732.4f, 525.3f, 743.5f, 525.3f),
                        PathNode.HorizontalTo(823.5f),
                        PathNode.QuadTo(834.6f, 525.3f, 839.1f, 530.4f),
                        PathNode.QuadTo(843.7f, 535.4f, 843.7f, 547.6f),
                        PathNode.Close,
                        PathNode.MoveTo(193.8f, 856.1f),
                        PathNode.QuadTo(212.2f, 890.0f, 242.5f, 903.9f),
                        PathNode.QuadTo(259.1f, 912.2f, 282.3f, 914.1f),
                        PathNode.QuadTo(305.5f, 915.9f, 358.7f, 915.9f),
                        PathNode.HorizontalTo(774.1f),
                        PathNode.QuadTo(827.3f, 915.9f, 850.0f, 914.1f),
                        PathNode.QuadTo(872.8f, 912.2f, 890.2f, 903.9f),
                        PathNode.QuadTo(922.4f, 887.4f, 938.1f, 856.1f),
                        PathNode.QuadTo(946.2f, 840.6f, 948.5f, 819.3f),
                        PathNode.QuadTo(950.9f, 798.0f, 950.1f, 761.5f),
                        PathNode.HorizontalTo(181.0f),
                        PathNode.QuadTo(181.9f, 798.8f, 184.2f, 819.8f),
                        PathNode.QuadTo(186.6f, 840.7f, 193.8f, 856.1f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _verticalsplitLight!!
    }

private var _verticalsplitLight: ImageVector? = null

val COUIIcons.Normal.VerticalSplit: ImageVector
    get() {
        if (_verticalsplitNormal != null) return _verticalsplitNormal!!
        _verticalsplitNormal = ImageVector.Builder(
            name = "VerticalSplit.Normal",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1154.2f,
            viewportHeight = 1154.2f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1154.2f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(935.3f, 180.8f),
                        PathNode.QuadTo(985.4f, 206.7f, 1008.6f, 254.0f),
                        PathNode.QuadTo(1022.5f, 280.9f, 1025.8f, 319.0f),
                        PathNode.QuadTo(1029.0f, 357.2f, 1029.0f, 446.8f),
                        PathNode.VerticalTo(708.4f),
                        PathNode.QuadTo(1029.0f, 798.1f, 1025.8f, 836.3f),
                        PathNode.QuadTo(1022.5f, 874.4f, 1008.6f, 901.3f),
                        PathNode.QuadTo(984.5f, 950.4f, 935.3f, 974.5f),
                        PathNode.QuadTo(908.5f, 988.4f, 870.4f, 991.7f),
                        PathNode.QuadTo(832.2f, 994.9f, 742.5f, 994.9f),
                        PathNode.HorizontalTo(410.8f),
                        PathNode.QuadTo(322.0f, 994.9f, 283.9f, 991.7f),
                        PathNode.QuadTo(245.8f, 988.4f, 218.0f, 974.5f),
                        PathNode.QuadTo(169.8f, 949.4f, 145.7f, 901.3f),
                        PathNode.QuadTo(131.8f, 874.4f, 128.5f, 836.3f),
                        PathNode.QuadTo(125.3f, 798.1f, 125.3f, 708.4f),
                        PathNode.VerticalTo(446.8f),
                        PathNode.QuadTo(125.3f, 357.2f, 128.5f, 319.0f),
                        PathNode.QuadTo(131.8f, 280.9f, 145.7f, 254.0f),
                        PathNode.QuadTo(168.9f, 207.7f, 218.0f, 180.8f),
                        PathNode.QuadTo(245.8f, 165.9f, 283.9f, 162.6f),
                        PathNode.QuadTo(322.0f, 159.4f, 410.8f, 159.4f),
                        PathNode.HorizontalTo(742.5f),
                        PathNode.QuadTo(832.2f, 159.4f, 870.4f, 162.6f),
                        PathNode.QuadTo(908.5f, 165.9f, 935.3f, 180.8f),
                        PathNode.Close,
                        PathNode.MoveTo(257.9f, 249.3f),
                        PathNode.QuadTo(229.4f, 264.5f, 213.3f, 292.0f),
                        PathNode.QuadTo(205.8f, 308.0f, 203.9f, 330.6f),
                        PathNode.QuadTo(202.0f, 353.2f, 202.0f, 403.8f),
                        PathNode.VerticalTo(704.2f),
                        PathNode.HorizontalTo(951.3f),
                        PathNode.VerticalTo(403.8f),
                        PathNode.QuadTo(951.3f, 353.2f, 949.5f, 330.6f),
                        PathNode.QuadTo(947.6f, 308.1f, 940.0f, 292.0f),
                        PathNode.QuadTo(926.8f, 267.3f, 896.4f, 249.3f),
                        PathNode.QuadTo(880.4f, 241.7f, 858.7f, 239.9f),
                        PathNode.QuadTo(837.0f, 238.0f, 784.6f, 238.0f),
                        PathNode.HorizontalTo(369.7f),
                        PathNode.QuadTo(317.3f, 238.0f, 295.1f, 239.9f),
                        PathNode.QuadTo(273.0f, 241.7f, 257.9f, 249.3f),
                        PathNode.Close,
                        PathNode.MoveTo(426.7f, 384.8f),
                        PathNode.VerticalTo(400.5f),
                        PathNode.QuadTo(426.7f, 417.4f, 420.4f, 424.6f),
                        PathNode.QuadTo(414.0f, 431.8f, 398.9f, 431.8f),
                        PathNode.HorizontalTo(321.8f),
                        PathNode.QuadTo(306.7f, 431.8f, 300.3f, 424.6f),
                        PathNode.QuadTo(294.0f, 417.4f, 294.0f, 400.5f),
                        PathNode.VerticalTo(384.8f),
                        PathNode.QuadTo(294.0f, 367.8f, 300.3f, 361.0f),
                        PathNode.QuadTo(306.6f, 354.2f, 321.8f, 354.2f),
                        PathNode.HorizontalTo(398.9f),
                        PathNode.QuadTo(414.1f, 354.2f, 420.4f, 361.0f),
                        PathNode.QuadTo(426.7f, 367.8f, 426.7f, 384.8f),
                        PathNode.Close,
                        PathNode.MoveTo(426.7f, 560.5f),
                        PathNode.VerticalTo(576.2f),
                        PathNode.QuadTo(426.7f, 593.1f, 420.4f, 600.3f),
                        PathNode.QuadTo(414.0f, 607.5f, 398.9f, 607.5f),
                        PathNode.HorizontalTo(321.8f),
                        PathNode.QuadTo(306.7f, 607.5f, 300.3f, 600.3f),
                        PathNode.QuadTo(294.0f, 593.1f, 294.0f, 576.2f),
                        PathNode.VerticalTo(560.5f),
                        PathNode.QuadTo(294.0f, 543.5f, 300.3f, 536.7f),
                        PathNode.QuadTo(306.6f, 529.9f, 321.8f, 529.9f),
                        PathNode.HorizontalTo(398.9f),
                        PathNode.QuadTo(414.1f, 529.9f, 420.4f, 536.7f),
                        PathNode.QuadTo(426.7f, 543.5f, 426.7f, 560.5f),
                        PathNode.Close,
                        PathNode.MoveTo(643.5f, 384.8f),
                        PathNode.VerticalTo(400.5f),
                        PathNode.QuadTo(643.5f, 417.4f, 637.2f, 424.6f),
                        PathNode.QuadTo(630.8f, 431.8f, 615.7f, 431.8f),
                        PathNode.HorizontalTo(538.6f),
                        PathNode.QuadTo(523.5f, 431.8f, 517.1f, 424.6f),
                        PathNode.QuadTo(510.8f, 417.4f, 510.8f, 400.5f),
                        PathNode.VerticalTo(384.8f),
                        PathNode.QuadTo(510.8f, 367.8f, 517.1f, 361.0f),
                        PathNode.QuadTo(523.4f, 354.2f, 538.6f, 354.2f),
                        PathNode.HorizontalTo(615.7f),
                        PathNode.QuadTo(630.9f, 354.2f, 637.2f, 361.0f),
                        PathNode.QuadTo(643.5f, 367.8f, 643.5f, 384.8f),
                        PathNode.Close,
                        PathNode.MoveTo(643.5f, 560.5f),
                        PathNode.VerticalTo(576.2f),
                        PathNode.QuadTo(643.5f, 593.1f, 637.2f, 600.3f),
                        PathNode.QuadTo(630.8f, 607.5f, 615.7f, 607.5f),
                        PathNode.HorizontalTo(538.6f),
                        PathNode.QuadTo(523.5f, 607.5f, 517.1f, 600.3f),
                        PathNode.QuadTo(510.8f, 593.1f, 510.8f, 576.2f),
                        PathNode.VerticalTo(560.5f),
                        PathNode.QuadTo(510.8f, 543.5f, 517.1f, 536.7f),
                        PathNode.QuadTo(523.4f, 529.9f, 538.6f, 529.9f),
                        PathNode.HorizontalTo(615.7f),
                        PathNode.QuadTo(630.9f, 529.9f, 637.2f, 536.7f),
                        PathNode.QuadTo(643.5f, 543.5f, 643.5f, 560.5f),
                        PathNode.Close,
                        PathNode.MoveTo(860.3f, 560.5f),
                        PathNode.VerticalTo(576.2f),
                        PathNode.QuadTo(860.3f, 593.1f, 853.9f, 600.3f),
                        PathNode.QuadTo(847.6f, 607.5f, 832.5f, 607.5f),
                        PathNode.HorizontalTo(755.4f),
                        PathNode.QuadTo(740.3f, 607.5f, 733.9f, 600.3f),
                        PathNode.QuadTo(727.6f, 593.1f, 727.6f, 576.2f),
                        PathNode.VerticalTo(560.5f),
                        PathNode.QuadTo(727.6f, 543.5f, 733.9f, 536.7f),
                        PathNode.QuadTo(740.2f, 529.9f, 755.4f, 529.9f),
                        PathNode.HorizontalTo(832.5f),
                        PathNode.QuadTo(847.7f, 529.9f, 854.0f, 536.7f),
                        PathNode.QuadTo(860.3f, 543.5f, 860.3f, 560.5f),
                        PathNode.Close,
                        PathNode.MoveTo(213.3f, 862.3f),
                        PathNode.QuadTo(230.4f, 892.7f, 257.9f, 905.9f),
                        PathNode.QuadTo(273.0f, 913.5f, 295.1f, 915.4f),
                        PathNode.QuadTo(317.3f, 917.2f, 369.7f, 917.2f),
                        PathNode.HorizontalTo(784.6f),
                        PathNode.QuadTo(837.0f, 917.2f, 858.7f, 915.4f),
                        PathNode.QuadTo(880.3f, 913.5f, 896.4f, 905.9f),
                        PathNode.QuadTo(925.8f, 890.8f, 940.0f, 862.3f),
                        PathNode.QuadTo(946.8f, 848.9f, 949.1f, 831.1f),
                        PathNode.QuadTo(951.4f, 813.3f, 951.3f, 780.9f),
                        PathNode.HorizontalTo(201.9f),
                        PathNode.QuadTo(202.9f, 813.4f, 205.2f, 831.6f),
                        PathNode.QuadTo(207.5f, 849.7f, 213.3f, 862.3f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _verticalsplitNormal!!
    }

private var _verticalsplitNormal: ImageVector? = null

val COUIIcons.Regular.VerticalSplit: ImageVector
    get() {
        if (_verticalsplitRegular != null) return _verticalsplitRegular!!
        _verticalsplitRegular = ImageVector.Builder(
            name = "VerticalSplit.Regular",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1164.0f,
            viewportHeight = 1164.0f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1164.0f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(941.7f, 182.3f),
                        PathNode.QuadTo(993.0f, 208.8f, 1016.7f, 257.3f),
                        PathNode.QuadTo(1031.0f, 284.8f, 1034.3f, 323.4f),
                        PathNode.QuadTo(1037.7f, 362.0f, 1037.7f, 451.8f),
                        PathNode.VerticalTo(713.1f),
                        PathNode.QuadTo(1037.7f, 803.0f, 1034.3f, 841.6f),
                        PathNode.QuadTo(1031.0f, 880.1f, 1016.7f, 907.6f),
                        PathNode.QuadTo(992.1f, 958.0f, 941.7f, 982.7f),
                        PathNode.QuadTo(914.2f, 996.9f, 875.6f, 1000.3f),
                        PathNode.QuadTo(837.0f, 1003.6f, 747.2f, 1003.6f),
                        PathNode.HorizontalTo(415.9f),
                        PathNode.QuadTo(327.0f, 1003.6f, 288.4f, 1000.3f),
                        PathNode.QuadTo(249.8f, 996.9f, 221.4f, 982.7f),
                        PathNode.QuadTo(172.0f, 957.3f, 147.3f, 907.6f),
                        PathNode.QuadTo(133.0f, 880.1f, 129.7f, 841.6f),
                        PathNode.QuadTo(126.3f, 803.0f, 126.3f, 713.1f),
                        PathNode.VerticalTo(451.8f),
                        PathNode.QuadTo(126.3f, 362.0f, 129.7f, 323.4f),
                        PathNode.QuadTo(133.0f, 284.8f, 147.3f, 257.3f),
                        PathNode.QuadTo(171.0f, 209.6f, 221.4f, 182.3f),
                        PathNode.QuadTo(249.8f, 167.1f, 288.4f, 163.7f),
                        PathNode.QuadTo(327.0f, 160.4f, 415.9f, 160.4f),
                        PathNode.HorizontalTo(747.2f),
                        PathNode.QuadTo(837.0f, 160.4f, 875.6f, 163.7f),
                        PathNode.QuadTo(914.2f, 167.1f, 941.7f, 182.3f),
                        PathNode.Close,
                        PathNode.MoveTo(265.1f, 258.4f),
                        PathNode.QuadTo(238.2f, 272.9f, 222.5f, 299.1f),
                        PathNode.QuadTo(215.2f, 314.5f, 213.5f, 336.6f),
                        PathNode.QuadTo(211.7f, 358.7f, 211.7f, 408.9f),
                        PathNode.VerticalTo(705.1f),
                        PathNode.HorizontalTo(951.3f),
                        PathNode.VerticalTo(408.9f),
                        PathNode.QuadTo(951.3f, 358.5f, 949.6f, 336.5f),
                        PathNode.QuadTo(947.8f, 314.5f, 940.6f, 299.1f),
                        PathNode.QuadTo(927.7f, 275.5f, 899.0f, 258.4f),
                        PathNode.QuadTo(883.5f, 251.2f, 862.4f, 249.4f),
                        PathNode.QuadTo(841.3f, 247.7f, 789.2f, 247.7f),
                        PathNode.HorizontalTo(374.8f),
                        PathNode.QuadTo(322.8f, 247.7f, 301.2f, 249.4f),
                        PathNode.QuadTo(279.5f, 251.2f, 265.1f, 258.4f),
                        PathNode.Close,
                        PathNode.MoveTo(433.3f, 389.6f),
                        PathNode.VerticalTo(405.6f),
                        PathNode.QuadTo(433.3f, 423.7f, 426.5f, 431.5f),
                        PathNode.QuadTo(419.6f, 439.3f, 403.5f, 439.3f),
                        PathNode.HorizontalTo(327.4f),
                        PathNode.QuadTo(311.4f, 439.3f, 304.5f, 431.5f),
                        PathNode.QuadTo(297.6f, 423.7f, 297.6f, 405.6f),
                        PathNode.VerticalTo(389.6f),
                        PathNode.QuadTo(297.6f, 371.4f, 304.5f, 364.2f),
                        PathNode.QuadTo(311.4f, 357.0f, 327.4f, 357.0f),
                        PathNode.HorizontalTo(403.5f),
                        PathNode.QuadTo(419.6f, 357.0f, 426.5f, 364.2f),
                        PathNode.QuadTo(433.3f, 371.4f, 433.3f, 389.6f),
                        PathNode.Close,
                        PathNode.MoveTo(433.3f, 565.2f),
                        PathNode.VerticalTo(581.2f),
                        PathNode.QuadTo(433.3f, 599.2f, 426.5f, 607.0f),
                        PathNode.QuadTo(419.6f, 614.8f, 403.5f, 614.8f),
                        PathNode.HorizontalTo(327.4f),
                        PathNode.QuadTo(311.4f, 614.8f, 304.5f, 607.0f),
                        PathNode.QuadTo(297.6f, 599.2f, 297.6f, 581.2f),
                        PathNode.VerticalTo(565.2f),
                        PathNode.QuadTo(297.6f, 547.1f, 304.5f, 539.7f),
                        PathNode.QuadTo(311.4f, 532.4f, 327.4f, 532.4f),
                        PathNode.HorizontalTo(403.5f),
                        PathNode.QuadTo(419.6f, 532.4f, 426.5f, 539.7f),
                        PathNode.QuadTo(433.3f, 547.1f, 433.3f, 565.2f),
                        PathNode.Close,
                        PathNode.MoveTo(649.8f, 389.6f),
                        PathNode.VerticalTo(405.6f),
                        PathNode.QuadTo(649.8f, 423.7f, 643.0f, 431.5f),
                        PathNode.QuadTo(636.2f, 439.3f, 620.1f, 439.3f),
                        PathNode.HorizontalTo(544.0f),
                        PathNode.QuadTo(527.9f, 439.3f, 521.0f, 431.5f),
                        PathNode.QuadTo(514.2f, 423.7f, 514.2f, 405.6f),
                        PathNode.VerticalTo(389.6f),
                        PathNode.QuadTo(514.2f, 371.4f, 521.0f, 364.2f),
                        PathNode.QuadTo(527.9f, 357.0f, 544.0f, 357.0f),
                        PathNode.HorizontalTo(620.1f),
                        PathNode.QuadTo(636.2f, 357.0f, 643.0f, 364.2f),
                        PathNode.QuadTo(649.8f, 371.4f, 649.8f, 389.6f),
                        PathNode.Close,
                        PathNode.MoveTo(649.8f, 565.2f),
                        PathNode.VerticalTo(581.2f),
                        PathNode.QuadTo(649.8f, 599.2f, 643.0f, 607.0f),
                        PathNode.QuadTo(636.2f, 614.8f, 620.1f, 614.8f),
                        PathNode.HorizontalTo(544.0f),
                        PathNode.QuadTo(527.9f, 614.8f, 521.0f, 607.0f),
                        PathNode.QuadTo(514.2f, 599.2f, 514.2f, 581.2f),
                        PathNode.VerticalTo(565.2f),
                        PathNode.QuadTo(514.2f, 547.1f, 521.0f, 539.7f),
                        PathNode.QuadTo(527.9f, 532.4f, 544.0f, 532.4f),
                        PathNode.HorizontalTo(620.1f),
                        PathNode.QuadTo(636.2f, 532.4f, 643.0f, 539.7f),
                        PathNode.QuadTo(649.8f, 547.1f, 649.8f, 565.2f),
                        PathNode.Close,
                        PathNode.MoveTo(866.4f, 565.2f),
                        PathNode.VerticalTo(581.2f),
                        PathNode.QuadTo(866.4f, 599.2f, 859.5f, 607.0f),
                        PathNode.QuadTo(852.7f, 614.8f, 836.6f, 614.8f),
                        PathNode.HorizontalTo(760.5f),
                        PathNode.QuadTo(744.4f, 614.8f, 737.5f, 607.0f),
                        PathNode.QuadTo(730.7f, 599.2f, 730.7f, 581.2f),
                        PathNode.VerticalTo(565.2f),
                        PathNode.QuadTo(730.7f, 547.1f, 737.5f, 539.7f),
                        PathNode.QuadTo(744.4f, 532.4f, 760.5f, 532.4f),
                        PathNode.HorizontalTo(836.6f),
                        PathNode.QuadTo(852.7f, 532.4f, 859.5f, 539.7f),
                        PathNode.QuadTo(866.4f, 547.1f, 866.4f, 565.2f),
                        PathNode.Close,
                        PathNode.MoveTo(222.5f, 864.9f),
                        PathNode.QuadTo(238.7f, 893.7f, 265.1f, 906.5f),
                        PathNode.QuadTo(279.5f, 913.8f, 301.2f, 915.5f),
                        PathNode.QuadTo(322.8f, 917.3f, 374.8f, 917.3f),
                        PathNode.HorizontalTo(789.2f),
                        PathNode.QuadTo(841.3f, 917.3f, 862.4f, 915.5f),
                        PathNode.QuadTo(883.5f, 913.8f, 899.0f, 906.5f),
                        PathNode.QuadTo(927.0f, 891.8f, 940.6f, 864.9f),
                        PathNode.QuadTo(946.7f, 852.5f, 949.0f, 835.9f),
                        PathNode.QuadTo(951.3f, 819.2f, 951.3f, 789.5f),
                        PathNode.HorizontalTo(211.7f),
                        PathNode.QuadTo(212.7f, 819.7f, 214.9f, 836.5f),
                        PathNode.QuadTo(217.1f, 853.2f, 222.5f, 864.9f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _verticalsplitRegular!!
    }

private var _verticalsplitRegular: ImageVector? = null

val COUIIcons.Medium.VerticalSplit: ImageVector
    get() {
        if (_verticalsplitMedium != null) return _verticalsplitMedium!!
        _verticalsplitMedium = ImageVector.Builder(
            name = "VerticalSplit.Medium",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1183.8f,
            viewportHeight = 1183.8f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1183.8f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(954.7f, 185.5f),
                        PathNode.QuadTo(1008.3f, 213.2f, 1033.2f, 264.0f),
                        PathNode.QuadTo(1048.0f, 292.6f, 1051.6f, 332.1f),
                        PathNode.QuadTo(1055.3f, 371.5f, 1055.3f, 461.8f),
                        PathNode.VerticalTo(722.8f),
                        PathNode.QuadTo(1055.3f, 813.1f, 1051.6f, 852.6f),
                        PathNode.QuadTo(1048.0f, 892.0f, 1033.2f, 920.7f),
                        PathNode.QuadTo(1007.3f, 973.3f, 954.7f, 999.2f),
                        PathNode.QuadTo(926.0f, 1014.0f, 886.6f, 1017.6f),
                        PathNode.QuadTo(847.2f, 1021.3f, 756.9f, 1021.3f),
                        PathNode.HorizontalTo(425.9f),
                        PathNode.QuadTo(336.6f, 1021.3f, 297.1f, 1017.6f),
                        PathNode.QuadTo(257.7f, 1014.0f, 228.1f, 999.2f),
                        PathNode.QuadTo(176.4f, 973.2f, 150.5f, 920.7f),
                        PathNode.QuadTo(135.7f, 892.0f, 132.1f, 852.6f),
                        PathNode.QuadTo(128.4f, 813.1f, 128.4f, 722.8f),
                        PathNode.VerticalTo(461.8f),
                        PathNode.QuadTo(128.4f, 371.5f, 132.1f, 332.1f),
                        PathNode.QuadTo(135.7f, 292.6f, 150.5f, 264.0f),
                        PathNode.QuadTo(175.5f, 213.3f, 228.1f, 185.5f),
                        PathNode.QuadTo(257.7f, 169.7f, 297.1f, 166.1f),
                        PathNode.QuadTo(336.6f, 162.4f, 425.9f, 162.4f),
                        PathNode.HorizontalTo(756.9f),
                        PathNode.QuadTo(847.2f, 162.4f, 886.6f, 166.1f),
                        PathNode.QuadTo(926.0f, 169.7f, 954.7f, 185.5f),
                        PathNode.Close,
                        PathNode.MoveTo(278.8f, 275.8f),
                        PathNode.QuadTo(254.9f, 289.1f, 239.9f, 312.9f),
                        PathNode.QuadTo(233.2f, 327.1f, 231.8f, 348.3f),
                        PathNode.QuadTo(230.3f, 369.4f, 230.3f, 418.9f),
                        PathNode.VerticalTo(708.3f),
                        PathNode.HorizontalTo(952.4f),
                        PathNode.VerticalTo(418.9f),
                        PathNode.QuadTo(952.4f, 368.6f, 951.0f, 347.9f),
                        PathNode.QuadTo(949.5f, 327.1f, 942.9f, 312.9f),
                        PathNode.QuadTo(930.6f, 291.1f, 904.9f, 275.8f),
                        PathNode.QuadTo(890.6f, 269.1f, 870.4f, 267.7f),
                        PathNode.QuadTo(850.2f, 266.2f, 798.8f, 266.2f),
                        PathNode.HorizontalTo(384.9f),
                        PathNode.QuadTo(333.5f, 266.2f, 312.8f, 267.7f),
                        PathNode.QuadTo(292.1f, 269.1f, 278.8f, 275.8f),
                        PathNode.Close,
                        PathNode.MoveTo(445.1f, 397.9f),
                        PathNode.VerticalTo(416.8f),
                        PathNode.QuadTo(445.1f, 436.2f, 437.4f, 444.8f),
                        PathNode.QuadTo(429.7f, 453.5f, 413.0f, 453.5f),
                        PathNode.HorizontalTo(338.2f),
                        PathNode.QuadTo(321.5f, 453.5f, 313.8f, 444.8f),
                        PathNode.QuadTo(306.0f, 436.2f, 306.0f, 416.8f),
                        PathNode.VerticalTo(397.9f),
                        PathNode.QuadTo(306.0f, 378.5f, 313.8f, 370.7f),
                        PathNode.QuadTo(321.5f, 362.9f, 338.2f, 362.9f),
                        PathNode.HorizontalTo(413.0f),
                        PathNode.QuadTo(429.7f, 362.9f, 437.4f, 370.7f),
                        PathNode.QuadTo(445.1f, 378.5f, 445.1f, 397.9f),
                        PathNode.Close,
                        PathNode.MoveTo(445.1f, 573.9f),
                        PathNode.VerticalTo(592.9f),
                        PathNode.QuadTo(445.1f, 611.4f, 437.4f, 620.1f),
                        PathNode.QuadTo(429.7f, 628.8f, 413.0f, 628.8f),
                        PathNode.HorizontalTo(338.2f),
                        PathNode.QuadTo(321.5f, 628.8f, 313.8f, 620.1f),
                        PathNode.QuadTo(306.0f, 611.4f, 306.0f, 592.9f),
                        PathNode.VerticalTo(573.9f),
                        PathNode.QuadTo(306.0f, 554.6f, 313.8f, 546.4f),
                        PathNode.QuadTo(321.5f, 538.2f, 338.2f, 538.2f),
                        PathNode.HorizontalTo(413.0f),
                        PathNode.QuadTo(429.7f, 538.2f, 437.4f, 546.4f),
                        PathNode.QuadTo(445.1f, 554.6f, 445.1f, 573.9f),
                        PathNode.Close,
                        PathNode.MoveTo(661.4f, 397.9f),
                        PathNode.VerticalTo(416.8f),
                        PathNode.QuadTo(661.4f, 436.2f, 653.7f, 444.8f),
                        PathNode.QuadTo(645.9f, 453.5f, 629.3f, 453.5f),
                        PathNode.HorizontalTo(554.5f),
                        PathNode.QuadTo(537.8f, 453.5f, 530.1f, 444.8f),
                        PathNode.QuadTo(522.3f, 436.2f, 522.3f, 416.8f),
                        PathNode.VerticalTo(397.9f),
                        PathNode.QuadTo(522.3f, 378.5f, 530.1f, 370.7f),
                        PathNode.QuadTo(537.8f, 362.9f, 554.5f, 362.9f),
                        PathNode.HorizontalTo(629.3f),
                        PathNode.QuadTo(645.9f, 362.9f, 653.7f, 370.7f),
                        PathNode.QuadTo(661.4f, 378.5f, 661.4f, 397.9f),
                        PathNode.Close,
                        PathNode.MoveTo(661.4f, 573.9f),
                        PathNode.VerticalTo(592.9f),
                        PathNode.QuadTo(661.4f, 611.4f, 653.7f, 620.1f),
                        PathNode.QuadTo(645.9f, 628.8f, 629.3f, 628.8f),
                        PathNode.HorizontalTo(554.5f),
                        PathNode.QuadTo(537.8f, 628.8f, 530.1f, 620.1f),
                        PathNode.QuadTo(522.3f, 611.4f, 522.3f, 592.9f),
                        PathNode.VerticalTo(573.9f),
                        PathNode.QuadTo(522.3f, 554.6f, 530.1f, 546.4f),
                        PathNode.QuadTo(537.8f, 538.2f, 554.5f, 538.2f),
                        PathNode.HorizontalTo(629.3f),
                        PathNode.QuadTo(645.9f, 538.2f, 653.7f, 546.4f),
                        PathNode.QuadTo(661.4f, 554.6f, 661.4f, 573.9f),
                        PathNode.Close,
                        PathNode.MoveTo(877.7f, 573.9f),
                        PathNode.VerticalTo(592.9f),
                        PathNode.QuadTo(877.7f, 611.4f, 869.9f, 620.1f),
                        PathNode.QuadTo(862.2f, 628.8f, 845.5f, 628.8f),
                        PathNode.HorizontalTo(770.7f),
                        PathNode.QuadTo(754.1f, 628.8f, 746.3f, 620.1f),
                        PathNode.QuadTo(738.6f, 611.4f, 738.6f, 592.9f),
                        PathNode.VerticalTo(573.9f),
                        PathNode.QuadTo(738.6f, 554.6f, 746.3f, 546.4f),
                        PathNode.QuadTo(754.1f, 538.2f, 770.7f, 538.2f),
                        PathNode.HorizontalTo(845.5f),
                        PathNode.QuadTo(862.2f, 538.2f, 869.9f, 546.4f),
                        PathNode.QuadTo(877.7f, 554.6f, 877.7f, 573.9f),
                        PathNode.Close,
                        PathNode.MoveTo(239.9f, 870.9f),
                        PathNode.QuadTo(254.3f, 896.6f, 278.8f, 908.9f),
                        PathNode.QuadTo(292.1f, 915.5f, 312.8f, 917.0f),
                        PathNode.QuadTo(333.5f, 918.4f, 384.9f, 918.4f),
                        PathNode.HorizontalTo(798.8f),
                        PathNode.QuadTo(850.2f, 918.4f, 870.4f, 917.0f),
                        PathNode.QuadTo(890.6f, 915.5f, 904.9f, 908.9f),
                        PathNode.QuadTo(930.5f, 894.8f, 942.9f, 870.9f),
                        PathNode.QuadTo(947.8f, 860.2f, 950.1f, 845.4f),
                        PathNode.QuadTo(952.4f, 830.6f, 952.4f, 806.2f),
                        PathNode.HorizontalTo(230.3f),
                        PathNode.QuadTo(231.3f, 832.2f, 233.2f, 846.3f),
                        PathNode.QuadTo(235.1f, 860.3f, 239.9f, 870.9f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _verticalsplitMedium!!
    }

private var _verticalsplitMedium: ImageVector? = null

val COUIIcons.Demibold.VerticalSplit: ImageVector
    get() {
        if (_verticalsplitDemibold != null) return _verticalsplitDemibold!!
        _verticalsplitDemibold = ImageVector.Builder(
            name = "VerticalSplit.Demibold",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1197.6f,
            viewportHeight = 1197.6f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1197.6f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(963.8f, 187.8f),
                        PathNode.QuadTo(1019.0f, 216.3f, 1044.7f, 268.7f),
                        PathNode.QuadTo(1059.9f, 298.2f, 1063.8f, 338.2f),
                        PathNode.QuadTo(1067.7f, 378.2f, 1067.7f, 468.8f),
                        PathNode.VerticalTo(729.6f),
                        PathNode.QuadTo(1067.7f, 820.3f, 1063.8f, 860.3f),
                        PathNode.QuadTo(1059.9f, 900.4f, 1044.7f, 929.8f),
                        PathNode.QuadTo(1018.0f, 984.0f, 963.8f, 1010.7f),
                        PathNode.QuadTo(934.3f, 1025.9f, 894.3f, 1029.8f),
                        PathNode.QuadTo(854.3f, 1033.7f, 763.6f, 1033.7f),
                        PathNode.HorizontalTo(433.0f),
                        PathNode.QuadTo(343.3f, 1033.7f, 303.3f, 1029.8f),
                        PathNode.QuadTo(263.3f, 1025.9f, 232.8f, 1010.7f),
                        PathNode.QuadTo(179.5f, 984.3f, 152.9f, 929.8f),
                        PathNode.QuadTo(137.7f, 900.4f, 133.8f, 860.3f),
                        PathNode.QuadTo(129.9f, 820.3f, 129.9f, 729.6f),
                        PathNode.VerticalTo(468.8f),
                        PathNode.QuadTo(129.9f, 378.2f, 133.8f, 338.2f),
                        PathNode.QuadTo(137.7f, 298.2f, 152.9f, 268.7f),
                        PathNode.QuadTo(178.6f, 216.0f, 232.8f, 187.8f),
                        PathNode.QuadTo(263.3f, 171.7f, 303.3f, 167.8f),
                        PathNode.QuadTo(343.3f, 163.9f, 433.0f, 163.9f),
                        PathNode.HorizontalTo(763.6f),
                        PathNode.QuadTo(854.3f, 163.9f, 894.3f, 167.8f),
                        PathNode.QuadTo(934.3f, 171.7f, 963.8f, 187.8f),
                        PathNode.Close,
                        PathNode.MoveTo(288.5f, 288.0f),
                        PathNode.QuadTo(266.7f, 300.4f, 252.1f, 322.5f),
                        PathNode.QuadTo(245.9f, 335.9f, 244.6f, 356.4f),
                        PathNode.QuadTo(243.4f, 376.9f, 243.4f, 426.0f),
                        PathNode.VerticalTo(710.6f),
                        PathNode.HorizontalTo(953.3f),
                        PathNode.VerticalTo(426.0f),
                        PathNode.QuadTo(953.3f, 375.7f, 952.0f, 355.8f),
                        PathNode.QuadTo(950.8f, 335.9f, 944.5f, 322.5f),
                        PathNode.QuadTo(932.7f, 302.0f, 909.0f, 288.0f),
                        PathNode.QuadTo(895.7f, 281.7f, 876.1f, 280.5f),
                        PathNode.QuadTo(856.5f, 279.2f, 805.5f, 279.2f),
                        PathNode.HorizontalTo(392.0f),
                        PathNode.QuadTo(341.1f, 279.2f, 321.0f, 280.5f),
                        PathNode.QuadTo(301.0f, 281.7f, 288.5f, 288.0f),
                        PathNode.Close,
                        PathNode.MoveTo(453.5f, 403.7f),
                        PathNode.VerticalTo(424.7f),
                        PathNode.QuadTo(453.5f, 444.9f, 445.0f, 454.2f),
                        PathNode.QuadTo(436.7f, 463.5f, 419.7f, 463.5f),
                        PathNode.HorizontalTo(345.7f),
                        PathNode.QuadTo(328.7f, 463.5f, 320.3f, 454.2f),
                        PathNode.QuadTo(312.0f, 444.9f, 312.0f, 424.7f),
                        PathNode.VerticalTo(403.7f),
                        PathNode.QuadTo(312.0f, 383.6f, 320.3f, 375.3f),
                        PathNode.QuadTo(328.7f, 367.1f, 345.7f, 367.1f),
                        PathNode.HorizontalTo(419.7f),
                        PathNode.QuadTo(436.7f, 367.1f, 445.0f, 375.3f),
                        PathNode.QuadTo(453.5f, 383.6f, 453.5f, 403.7f),
                        PathNode.Close,
                        PathNode.MoveTo(453.5f, 580.0f),
                        PathNode.VerticalTo(601.1f),
                        PathNode.QuadTo(453.5f, 620.0f, 445.0f, 629.3f),
                        PathNode.QuadTo(436.7f, 638.6f, 419.7f, 638.6f),
                        PathNode.HorizontalTo(345.7f),
                        PathNode.QuadTo(328.7f, 638.6f, 320.3f, 629.3f),
                        PathNode.QuadTo(312.0f, 620.0f, 312.0f, 601.1f),
                        PathNode.VerticalTo(580.0f),
                        PathNode.QuadTo(312.0f, 559.9f, 320.3f, 551.1f),
                        PathNode.QuadTo(328.7f, 542.2f, 345.7f, 542.2f),
                        PathNode.HorizontalTo(419.7f),
                        PathNode.QuadTo(436.7f, 542.2f, 445.0f, 551.1f),
                        PathNode.QuadTo(453.5f, 559.9f, 453.5f, 580.0f),
                        PathNode.Close,
                        PathNode.MoveTo(669.5f, 403.7f),
                        PathNode.VerticalTo(424.7f),
                        PathNode.QuadTo(669.5f, 444.9f, 661.1f, 454.2f),
                        PathNode.QuadTo(652.8f, 463.5f, 635.7f, 463.5f),
                        PathNode.HorizontalTo(561.8f),
                        PathNode.QuadTo(544.7f, 463.5f, 536.4f, 454.2f),
                        PathNode.QuadTo(528.1f, 444.9f, 528.1f, 424.7f),
                        PathNode.VerticalTo(403.7f),
                        PathNode.QuadTo(528.1f, 383.6f, 536.4f, 375.3f),
                        PathNode.QuadTo(544.7f, 367.1f, 561.8f, 367.1f),
                        PathNode.HorizontalTo(635.7f),
                        PathNode.QuadTo(652.8f, 367.1f, 661.1f, 375.3f),
                        PathNode.QuadTo(669.5f, 383.6f, 669.5f, 403.7f),
                        PathNode.Close,
                        PathNode.MoveTo(669.5f, 580.0f),
                        PathNode.VerticalTo(601.1f),
                        PathNode.QuadTo(669.5f, 620.0f, 661.1f, 629.3f),
                        PathNode.QuadTo(652.8f, 638.6f, 635.7f, 638.6f),
                        PathNode.HorizontalTo(561.8f),
                        PathNode.QuadTo(544.7f, 638.6f, 536.4f, 629.3f),
                        PathNode.QuadTo(528.1f, 620.0f, 528.1f, 601.1f),
                        PathNode.VerticalTo(580.0f),
                        PathNode.QuadTo(528.1f, 559.9f, 536.4f, 551.1f),
                        PathNode.QuadTo(544.7f, 542.2f, 561.8f, 542.2f),
                        PathNode.HorizontalTo(635.7f),
                        PathNode.QuadTo(652.8f, 542.2f, 661.1f, 551.1f),
                        PathNode.QuadTo(669.5f, 559.9f, 669.5f, 580.0f),
                        PathNode.Close,
                        PathNode.MoveTo(885.6f, 580.0f),
                        PathNode.VerticalTo(601.1f),
                        PathNode.QuadTo(885.6f, 620.0f, 877.2f, 629.3f),
                        PathNode.QuadTo(868.9f, 638.6f, 851.8f, 638.6f),
                        PathNode.HorizontalTo(777.9f),
                        PathNode.QuadTo(760.8f, 638.6f, 752.5f, 629.3f),
                        PathNode.QuadTo(744.1f, 620.0f, 744.1f, 601.1f),
                        PathNode.VerticalTo(580.0f),
                        PathNode.QuadTo(744.1f, 559.9f, 752.5f, 551.1f),
                        PathNode.QuadTo(760.8f, 542.2f, 777.9f, 542.2f),
                        PathNode.HorizontalTo(851.8f),
                        PathNode.QuadTo(868.9f, 542.2f, 877.2f, 551.1f),
                        PathNode.QuadTo(885.6f, 559.9f, 885.6f, 580.0f),
                        PathNode.Close,
                        PathNode.MoveTo(252.1f, 875.0f),
                        PathNode.QuadTo(265.2f, 898.7f, 288.5f, 910.5f),
                        PathNode.QuadTo(301.0f, 916.8f, 321.0f, 918.0f),
                        PathNode.QuadTo(341.1f, 919.3f, 392.0f, 919.3f),
                        PathNode.HorizontalTo(805.5f),
                        PathNode.QuadTo(856.5f, 919.3f, 876.1f, 918.0f),
                        PathNode.QuadTo(895.7f, 916.8f, 909.0f, 910.5f),
                        PathNode.QuadTo(933.0f, 896.9f, 944.5f, 875.0f),
                        PathNode.QuadTo(948.6f, 865.7f, 951.0f, 852.1f),
                        PathNode.QuadTo(953.3f, 838.6f, 953.3f, 817.9f),
                        PathNode.HorizontalTo(243.4f),
                        PathNode.QuadTo(244.3f, 841.0f, 246.0f, 853.2f),
                        PathNode.QuadTo(247.8f, 865.4f, 252.1f, 875.0f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _verticalsplitDemibold!!
    }

private var _verticalsplitDemibold: ImageVector? = null
